class ApexAnchorNavigator {
  constructor({ container, containerWrapper, containerMain, anchorSelector }) {
    this.container = document.querySelector(container);
    this.wrapper = document.querySelector(containerWrapper);
    this.containerMain = document.querySelector(containerMain);
    this.anchors = document.querySelectorAll(anchorSelector);

    if (!this.containerMain || !this.anchors.length) {
      console.error("容器或锚点未找到");
      this.container.remove();
      return;
    }

    this.init();
  }

  // 初始化方法：获取锚点数据并填充进容器
  init() {
    this.setWrapperTop();
    this.createAnchorItems();
    this.bindEvents();
    this.addScrollListener();
  }

  setWrapperTop() {
    const asideTop = document.querySelector("aside.shopify-section--announcement-bar")?.clientHeight || 0;
    const headerDom = document.querySelector("header.shopify-section--header");
    let headerTop = headerDom?.clientHeight || 0;
    if (headerDom.style.visibility == "hidden") {
      headerTop = 0;
    }
    const dealTop = document.querySelector(".kospet-section--hot-deals")?.clientHeight || 0;
    const pageHeaderHeight = Math.floor(asideTop + headerTop + dealTop);
    if (this.pageHeaderHeight == pageHeaderHeight) {
      return;
    }
    this.wrapper.style.transition = "top 0.1s linear, height .2s";
    this.wrapper.style.top = `${pageHeaderHeight}px`;
    this.pageHeaderHeight = pageHeaderHeight;
  }

  createAnchorItems() {
    this.containerMain.innerHTML = ""; // 清空容器
    this.anchors.forEach((anchor) => {
      const anchorTarget = anchor.getAttribute("data-apex-anchor");
      const anchorText = anchor.getAttribute("data-apex-anchor-text");
      if (!anchorText) return;
      const span = document.createElement("span");
      span.classList.add("anchor-item");
      span.textContent = anchorText;
      span.dataset.apexAnchorTo = anchorTarget;
      span.dataset.link = anchor.getAttribute("data-apex-anchor-link");
      this.containerMain.appendChild(span);
    });
  }

  bindEvents() {
    this.spans = this.wrapper.querySelectorAll(".anchor-item");
    this.spans.forEach((span) => {
      span.addEventListener("click", (e) => {
        if(span.dataset.link) {
          window.location.href = span.dataset.link;
          return;
        }
        const anchorTarget = span.dataset.apexAnchorTo;
        const anchor = document.querySelector(`[data-apex-anchor="${anchorTarget}"]`);
        this.scrollToAnchor(anchor);
      });
    });
  }

  // 监听滚动事件
  addScrollListener() {
    window.addEventListener("scroll", () => {
      this.setWrapperTop();
      this.toggleContainerActive();
      this.highlightActiveAnchor();
    });
  }

  // 处理容器的 active 类
  toggleContainerActive() {
    if (this.container.getBoundingClientRect().y <= this.pageHeaderHeight + 60) {
      this.wrapper.classList.add("active");
    } else {
      this.wrapper.classList.remove("active");
    }
  }

  // 高亮当前滚动到的锚点
  highlightActiveAnchor() {
    const allAnchors = document.querySelectorAll(`[data-apex-anchor]`);
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    let activeAnchor = null;
    allAnchors.forEach((anchor) => {
      const rect = anchor.getBoundingClientRect();
      if (rect.top <= this.pageHeaderHeight + 60) {
        activeAnchor = anchor;
      }
    });
    if (activeAnchor) {
      const anchorTarget = activeAnchor.getAttribute("data-apex-anchor");
      const activeSpan = this.wrapper.querySelector(`.anchor-item[data-apex-anchor-to="${anchorTarget}"]`);
      if (activeSpan && !activeSpan.dataset.link) {
        this.spans.forEach((span) => span.classList.remove("active"));
        activeSpan.classList.add("active");
      }
    }
  }

  // 点击 span 滚动到对应锚点
  scrollToAnchor(anchor) {
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth" });
    }
  }
}

window.ApexAnchorNavigator = ApexAnchorNavigator;
